import React, { Component } from 'react';
import { Carousel } from 'antd';
import bannerDefault from '../../images/phone_bg.png';
import styles from './index.less';

export default class Banner extends Component {
  render() {
    const { bannerData = [], carouselModule = {} } = this.props;
    const { moduleType } = carouselModule;
    return (
      <div className={styles.banner}>
        {bannerData.length > 0 && (
          <Carousel autoplay>
            {bannerData.map(val => (
              <a className="img-wrap" key={val}>
                <img
                  src={moduleType === 2 ? val : val.coverPicFileUrl || bannerDefault}
                  alt=""
                  style={{ width: '100%', verticalAlign: 'top', maxHeight: 120 }}
                />
                {val.title && (
                  <>
                    <span className="mask" />
                    <span className="text">{val.title}</span>
                  </>
                )}
              </a>
            ))}
          </Carousel>
        )}
      </div>
    );
  }
}
